module.exports = __webpack_public_path__ + "static/Resume_TakahideNakamura-05ecc1d5efb21237ac7f3a24a1e4283e.pdf";